import * as React from 'react'
import * as css from './HeaderLinks.module.css'
import { GlobalContext } from '../Store'
import { graphql, useStaticQuery } from 'gatsby'
import Dropdown from './Dropdown'
import Megamenu from './Megamenu'
import SingleLink from './SingleLink'
import clsx from 'clsx'

export default function HeaderLinks() {
	const { mobileMenuState } = React.useContext(GlobalContext)
	const { sanityHeader } = useStaticQuery(query)

	return (
		<div
			className={clsx(
				css.root,
				!mobileMenuState && '<md:hidden',
				'<md:anim-fadein',
			)}
		>
			<ul className="flex items-center justify-center gap-x-8 gap-y-4 text-center md:flex-wrap <md:flex-col <md:px-4 <md:py-8">
				{sanityHeader.menu?.map((menu) => {
					switch (menu._type) {
						case 'menuGroup':
							return <Dropdown {...menu} key={menu._key} />

						case 'megamenu':
							return <Megamenu {...menu} key={menu._key} />

						default:
							return (
								<li key={menu._key}>
									<SingleLink {...menu} />
								</li>
							)
					}
				})}
			</ul>
		</div>
	)
}

// prettier-ignore
const query = graphql`
	query HeaderLinks {
		sanityHeader {
			menu {
				... on SanityMenuGroup {
					_type _key
					label
					link {
						... on SanityServicesPg { _type title seo { slug { current } } }
						... on SanityExpertisePg { _type title seo { slug { current } } }
						... on SanityProductsPg { _type title seo { slug { current } } }
						... on SanityPage { _type title seo { slug { current } } }
					}
					links {
						... on SanityServicesPg { _type title seo { slug { current } } }
						... on SanityExpertisePg { _type title seo { slug { current } } }
						... on SanityAltEnergyPg { _type title seo { slug { current } } }
						... on SanityHvacPg { _type title seo { slug { current } } }
						... on SanityProductsPg { _type title seo { slug { current } } }
						... on SanityPage { _type title seo { slug { current } } }
						...menuGroup
						...link
					}
				}
				... on SanityMegamenu {
					_type _key
					label
					link {
						... on SanityServicesPg { _type title seo { slug { current } } }
						... on SanityExpertisePg { _type title seo { slug { current } } }
						... on SanityProductsPg { _type title seo { slug { current } } }
						... on SanityPage { _type title seo { slug { current } } }
					}
					featuredLinks {
						page {
							... on SanityServicesPg { _type title seo { slug { current } } }
							... on SanityExpertisePg { _type title seo { slug { current } } }
							... on SanityAltEnergyPg { _type title seo { slug { current } } }
							... on SanityHvacPg { _type title seo { slug { current } } }
							... on SanityProductsPg { _type title seo { slug { current } } }
							... on SanityPage { _type title seo { slug { current } } }
						}
						description
						image { asset { gatsbyImageData(placeholder: NONE, aspectRatio: 4) } }
					}
					links {
						... on SanityServicesPg { _type title seo { slug { current } } }
						... on SanityExpertisePg { _type title seo { slug { current } } }
						... on SanityAltEnergyPg { _type title seo { slug { current } } }
						... on SanityHvacPg { _type title seo { slug { current } } }
						... on SanityProductsPg { _type title seo { slug { current } } }
						... on SanityPage { _type title seo { slug { current } } }
						...link
					}
				}
			}
		}
	}
`
